import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FleetInterface } from 'src/app/core/interfaces/fleet.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FleetsApiService {
  constructor(private http: HttpClient) {}

  fleetsURL = `${environment.apiUrl}/fleet_logos`;

  getFleets(): Observable<FleetInterface[]> {
    return this.http.get<FleetInterface[]>(this.fleetsURL);
  }

}
